import { RFPercentage } from 'react-native-responsive-fontsize';

export const BACK_BUTTON_MARGIN = 40;
export const CIRCLE_SIZE = 45;
export const CIRCLE_MARGIN = 7;
export const MAX_WIDTH = 500;
export const BIGGER_SPACING = RFPercentage(3);
export const TIMEOUT = 20000;



export const ORANGE = '#F9862D';
export const PRIMARY0= '#F0EEFC';
export const BLACK = '#000000';
export const LIGHT_GRAY_FOR_TEXT = '#BFBFBF';
export const YELLOW = '#fca503';
export const GRAY_BACKGROUND = '#eaeaea';

export const WARNING_COLOR = '#CD8156'; // this is different to COLORS.state.warning.primary
export const ERROR_COLOR = '#CC4F4F'; // this is different to COLORS.state.danger.primary

// COLORS.content.primary different to these
export const NEUTRAL_TEXT0 = '#FFFFFF';
export const NEUTRAL_TEXT10 = '#F1F1F1';
export const NEUTRAL_TEXT300 = '#73778C';
export const NEUTRAL_TEXT400 = '#50556F';
export const NEUTRAL_TEXT500 = '#2D3352';

export const LEFT_BREATHING_COLORS = ['#EA8CA3DD','#8D96EBDD', '#F6DD85FF', '#8DE5EBDD', '#DE8DEBDD'];
export const RIGHT_BREATHING_COLORS = ['#EAA88CDD','#B18DEBDD', '#B0EB8DFF', '#8D96EBDD', '#EA8CA3DD'];




export const colorsWithBrightnessRange = {
  brand: {
    1000: '#252150',
    900: '#2C2760',
    800: '#332D6F',
    700: '#443C94',
    600: '#554DB6',
    500: '#675BDF',
    400: '#7E74E4',
    300: '#938BE8',
    200: '#A9A3ED',
    100: '#BEBAF1',
    50: '#DFDCF8',
    10: '#E9E8FA'
  },
  moonstone: {
    1000: '#162D34',
    900: '#21444F',
    800: '#2C5B69',
    700: '#377183',
    600: '#42889D',
    500: '#4F9EB5',
    400: '#68ABC0',
    300: '#81B9CA',
    200: '#9AC7D5',
    100: '#B3D5DF',
    50: '#D9EAEF',
    10: '#E6F1F4'
  },
  gray: {
    1000: '#232A40',
    900: '#2C3550',
    800: '#354060',
    700: '#3D4A70',
    600: '#56689C',
    500: '#7F8DB9',
    400: '#ACB5D1',
    300: '#D8DDEA',
    200: '#EDEFF5',
    100: '#F7F8FA',
    50: '#FDFDFD',
    0: '#FFFFFF'
  },

  red: {
    1000: '#4F1414',
    900: '#6E1C1C',
    800: '#8E2323',
    700: '#AD2B2B',
    600: '#BD2F2F',
    500: '#D04444',
    400: '#D75E5E',
    300: '#DD7979',
    200: '#E49494',
    100: '#EBAFAF',
    50: '#F2C9C9',
    10: '#F8E4E4'
  },
  YELLOW: {
    1000: '#411A07',
    800: '#8B3F15',
    600: '#CE7211',
    500: '#E89718',
    400: '#EFB630',
    300: '#F3CB56',
    200: '#F6DD85',
    100: '#FBF0CA',
    50: '#FEFAEC',
  },
  LIGHT_GREEN: {
    1000: '#112A09',
    800: '#2C5A1A',
    600: '#41931D',
    500: '#58B929',
    400: '#78D447',
    300: '#9BE373',
    200: '#B0EB8D',
    100: '#DFF7D0',
    50: '#F1FCE9',
  },
  TURQUOISE: {
    1000: '#072C18',
    800: '#196238',
    600: '#1C9D51',
    500: '#29BE66',
    400: '#50D888',
    300: '#8DEBB3',
    200: '#BEF4D3',
    100: '#DDFBE8',
    50: '#F1FCF4',
  },
  ELECTRIC_BLUE: {
    1000: '#0F323D',
    800: '#215C69',
    600: '#1C8B9E',
    500: '#1FACBB',
    400: '#3BC9D5',
    300: '#8DE5EB',
    200: '#AFEFF2',
    100: '#D5F7F8',
    50: '#EEFDFD',
  },
  VISTA_BLUE: {
    1000: '#232046',
    800: '#423C97',
    600: '#5E57D4',
    500: '#7275E2',
    400: '#8D96EB',
    300: '#AEBAF3',
    200: '#CDD6F8',
    100: '#E3E9FC',
    50: '#F0F3FD',
  },
  LAVENDER: {
    1000: '#391A5B',
    800: '#6E33A4',
    600: '#944FD8',
    500: '#A16EE4',
    400: '#B18DEB',
    300: '#D0BDF5',
    200: '#E4DBF9',
    100: '#F1EBFC',
    50: '#F7F4FE',
  },
  VIOLET: {
    1000: '#420D45',
    800: '#7A2781',
    600: '#AF3ABF',
    500: '#C95ADB',
    400: '#DE8DEB',
    300: '#E9B4F3',
    200: '#F2D5F9',
    100: '#F8EBFC',
    50: '#FCF5FE',
  },
  PINK: {
    1000: '#420F22',
    800: '#8C254B',
    600: '#C73765',
    500: '#DC577B',
    400: '#EA8CA3',
    300: '#F1B0BE',
    200: '#F7D4DB',
    100: '#FBE8EB',
    50: '#FDF3F5',
  },
  TANGERINE: {
    1000: '#3E1E11',
    800: '#8A472A',
    600: '#C6653C',
    500: '#DB7F58',
    400: '#EAA88C',
    300: '#F2C3AF',
    200: '#F8DCD0',
    100: '#FBECE5',
    50: '#FDF6F3',
  }

};

const colors = {
  ...colorsWithBrightnessRange,
  green: {
    dark: '#4FB578',
    light: '#E6F4EC'
  },
  orange: {
    dark: '#FFB844',
    light: '#FFF5E4'
  },
};


export type designSystemColorType = keyof typeof colors;

export const COLORS = {
  ...colors,
  surface: {
    primary: colors.gray[50],
    secondary: colors.gray[100],
    tertiary: colors.gray[200],
    accent: colors.brand[10],
    ['inverse-primary']: colors.brand[500],
    contrast: colors.gray[0],
    'primary-dark': colors.brand[800],
  },
  content: {
    primary: colors.gray[800],
    secondary: colors.gray[700],
    tertiary: colors.gray[400],
    accent: colors.brand[500],
    ['inverse-primary']: colors.gray[50],
    ['accent-dark']: colors.brand[800]
  },
  border: {
    primary: colors.gray[300],
    secondary: colors.gray[200],
    accent: colors.brand[500],
    ['accent-dark']: colors.brand[800],
    ['accent-light']: colors.brand[50],
  },
  state: {
    info: {
      primary: colors.moonstone[500],
      ['inverse-primary']: colors.moonstone[10]
    },
    success: {
      primary: colors.green.dark,
      ['inverse-primary']: colors.green.light,
    },
    danger: {
      primary: colors.red[500],
      ['inverse-primary']: colors.red[10],
      accent: colors.red[800],
      ['inverse-accent']: colors.red[50],
    },
    warning: {
      primary: colors.orange.dark,
      ['inverse-primary']: colors.orange.light,
    },
  }
};

export interface Gradient {
  left: string;
  right: string;
  orientationAngle: number;
}

export interface ModuleGradient {
  base: Gradient;
  light: Gradient;
  dark: Gradient;
}

export type DesignSystemColors = 'YELLOW' | 'LIGHT_GREEN' | 'TURQUOISE' | 'ELECTRIC_BLUE' | 'VISTA_BLUE' | 'LAVENDER' | 'VIOLET' | 'PINK' | 'TANGERINE';

export interface GradientsType {
  brand: {
    [key2: string]: Gradient ;
  }
  modules: {
    [key3: string]: ModuleGradient;
  };

}


export const GRADIENTS :
GradientsType = {
  'brand': {
    ['primary-extra-light']: {
      left: COLORS.brand[100],
      right: COLORS.moonstone[10],
      orientationAngle: 109
    },
    ['primary-light']: {
      left: COLORS.brand[400],
      right: COLORS.brand[700],
      orientationAngle: 143
    },
    ['primary-base']: {
      left: COLORS.brand[500],
      right: COLORS.brand[500],
      orientationAngle: 143
    },
    ['primary-dark']: {
      left: COLORS.brand[800],
      right: COLORS.brand[600],
      orientationAngle: 143
    }
  },
  'modules': {
    YELLOW: {
      'light' : {
        left: COLORS.YELLOW[100],
        right: COLORS['LIGHT_GREEN'][100],
        orientationAngle: 68
      },
      'base' : {
        left: COLORS.YELLOW[200],
        right: COLORS['LIGHT_GREEN'][200],
        orientationAngle: 68
      },
      'dark' : {
        left: COLORS.YELLOW[300],
        right: COLORS['LIGHT_GREEN'][300],
        orientationAngle: 68
      }
    },
    LIGHT_GREEN: {
      'light' : {
        left: COLORS['LIGHT_GREEN'][100],
        right: COLORS.TURQUOISE[200],
        orientationAngle: 68
      },
      'base' : {
        left: COLORS['LIGHT_GREEN'][200],
        right: COLORS.TURQUOISE[300],
        orientationAngle: 68
      },
      'dark' : {
        left: COLORS['LIGHT_GREEN'][300],
        right: COLORS.TURQUOISE[400],
        orientationAngle: 68
      }
    },
    TURQUOISE: {
      'light' : {
        left: COLORS.TURQUOISE[100],
        right: COLORS['ELECTRIC_BLUE'][100],
        orientationAngle: 68
      },
      'base' : {
        left: COLORS.TURQUOISE[300],
        right: COLORS['ELECTRIC_BLUE'][300],
        orientationAngle: 68
      },
      'dark' : {
        left: COLORS.TURQUOISE[400],
        right: COLORS['ELECTRIC_BLUE'][400],
        orientationAngle: 68
      }
    },
    ELECTRIC_BLUE: {
      'light' : {
        left: COLORS['ELECTRIC_BLUE'][100],
        right: COLORS['VISTA_BLUE'][100],
        orientationAngle: 68
      },
      'base' : {
        left: COLORS['ELECTRIC_BLUE'][300],
        right: COLORS['VISTA_BLUE'][400],
        orientationAngle: 68
      },
      'dark' : {
        left: COLORS['ELECTRIC_BLUE'][400],
        right: COLORS['VISTA_BLUE'][500],
        orientationAngle: 68
      }
    },
    VISTA_BLUE: {
      'light' : {
        left: COLORS['VISTA_BLUE'][100],
        right: COLORS.LAVENDER[100],
        orientationAngle: 68
      },
      'base' : {
        left: COLORS['VISTA_BLUE'][400],
        right: COLORS.LAVENDER[400],
        orientationAngle: 68
      },
      'dark' : {
        left: COLORS['VISTA_BLUE'][500],
        right: COLORS.LAVENDER[500],
        orientationAngle: 68
      }
    },
    'LAVENDER': {
      'light' : {
        left: COLORS.LAVENDER[100],
        right: COLORS.VIOLET[100],
        orientationAngle: 68
      },
      'base' : {
        left: COLORS.LAVENDER[400],
        right: COLORS.VIOLET[400],
        orientationAngle: 68
      },
      'dark' : {
        left: COLORS.LAVENDER[500],
        right: COLORS.VIOLET[500],
        orientationAngle: 68
      }
    },
    'VIOLET': {
      'light' : {
        left: COLORS.VIOLET[100],
        right: COLORS.PINK[100],
        orientationAngle: 68
      },
      'base' : {
        left: COLORS.VIOLET[400],
        right: COLORS.PINK[400],
        orientationAngle: 68
      },
      'dark' : {
        left: COLORS.VIOLET[500],
        right: COLORS.PINK[500],
        orientationAngle: 68
      }
    },
    'PINK': {
      'light' : {
        left: COLORS.PINK[100],
        right: COLORS.TANGERINE[100],
        orientationAngle: 68
      },
      'base' : {
        left: COLORS.PINK[400],
        right: COLORS.TANGERINE[400],
        orientationAngle: 68
      },
      'dark' : {
        left: COLORS.PINK[500],
        right: COLORS.TANGERINE[500],
        orientationAngle: 68
      }
    },
    'TANGERINE': {
      'light' : {
        left: COLORS.TANGERINE[100],
        right: COLORS.YELLOW[100],
        orientationAngle: 68
      },
      'base' : {
        left: COLORS.TANGERINE[400],
        right: COLORS.YELLOW[200],
        orientationAngle: 68
      },
      'dark' : {
        left: COLORS.TANGERINE[600],
        right: COLORS.YELLOW[300],
        orientationAngle: 68
      }
    }

  }
};

export const BgOverlayLight = COLORS.brand[800]+'4D';





